"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _useDynamicFields = require("./useDynamicFields");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BUTTON_TOOLBAR_HOVER_COLOR = '#40A9FF';
var BACKGROUND_COLOR = '#FFFFFF';
var TAB_COLOR = '#1890FF';
var BUTTON_COLOR = '#6EBB83';
var BUTTON_HOVER_COLOR = '#91CBA1';
var ERROR_BOUNDARY_COLOR = '#F5222D';
var OverrideStyles = (0, _core.withStyles)({
  '@global': _objectSpread({
    '.jodit-rte-error': {
      '&&': {
        border: "1px solid ".concat(ERROR_BOUNDARY_COLOR)
      }
    },
    // Toolbar buttons
    '.jodit-toolbar-button__button': {
      '&&': {
        '&:hover': {
          boxShadow: 'none',
          backgroundColor: "".concat(BACKGROUND_COLOR),
          color: "".concat(BUTTON_TOOLBAR_HOVER_COLOR),
          '& > span > svg': {
            fill: "".concat(BUTTON_TOOLBAR_HOVER_COLOR)
          },
          cursor: 'pointer'
        },
        '&[aria-pressed="true"]': {
          boxShadow: 'none',
          backgroundColor: "".concat(BACKGROUND_COLOR),
          color: "".concat(BUTTON_TOOLBAR_HOVER_COLOR),
          '& > span > svg': {
            fill: "".concat(BUTTON_TOOLBAR_HOVER_COLOR)
          },
          '&:hover': {
            backgroundColor: "".concat(BACKGROUND_COLOR)
          }
        }
      }
    },
    // The toolbar buttons
    '.jodit-toolbar-button': {
      '&&': {
        margin: '2px 4px',
        padding: '1px',
        border: '1px solid #F1F1F1',
        '&:hover': {
          background: "".concat(BACKGROUND_COLOR),
          border: "1px solid ".concat(BUTTON_TOOLBAR_HOVER_COLOR),
          color: "".concat(BUTTON_TOOLBAR_HOVER_COLOR),
          '& > span > svg': {
            fill: "".concat(BUTTON_TOOLBAR_HOVER_COLOR)
          },
          cursor: 'pointer'
        },
        '&[aria-pressed="true"]': {
          border: "1px solid ".concat(BUTTON_TOOLBAR_HOVER_COLOR)
        }
      }
    },
    // Following add visual in front of dropdowns of types of ul and li tags
    '.jodit-toolbar-button_circle': {
      '&::before': {
        content: '"(◦)"',
        paddingLeft: '3px'
      }
    },
    '.jodit-toolbar-button_disc': {
      '&::before': {
        content: '"(•)"',
        paddingLeft: '3px'
      }
    },
    '.jodit-toolbar-button_square': {
      '&::before': {
        content: '"(■)"',
        paddingLeft: '3px'
      }
    },
    '.jodit-toolbar-button_lower_alpha': {
      '&::before': {
        content: '"(a)"',
        paddingLeft: '3px'
      }
    },
    '.jodit-toolbar-button_lower_greek': {
      '&::before': {
        content: '"(α)"',
        paddingLeft: '3px'
      }
    },
    '.jodit-toolbar-button_lower_roman': {
      '&::before': {
        content: '"(i)"',
        paddingLeft: '3px'
      }
    },
    '.jodit-toolbar-button_upper_alpha': {
      '&::before': {
        content: '"(A)"',
        paddingLeft: '3px'
      }
    },
    '.jodit-toolbar-button_upper_roman': {
      '&::before': {
        content: '"(I)"',
        paddingLeft: '3px'
      }
    },
    // The toolbar container
    '.jodit-toolbar__box': {
      '&&': {
        padding: '6px 5px 3px',
        backgroundColor: "".concat(BACKGROUND_COLOR)
      }
    },
    // The "Open in new tab" Checkbox in adding a link dropdown
    '.jodit-t__input': {
      '&[type="checkbox"]': {
        margin: '5px'
      }
    },
    // The dropdown arrow buttons in the toolbar buttons
    '.jodit-toolbar-button__trigger': {
      '&&': {
        '&:hover': {
          backgroundColor: "".concat(BACKGROUND_COLOR)
        }
      }
    },
    // Remove the divider between toolbar buttons when they wrap into next line
    '.jodit-toolbar-editor-collection_size_middle.jodit-toolbar-editor-collection_mode_horizontal,.jodit-toolbar-editor-collection_mode_horizontal': {
      '&&': {
        backgroundImage: 'none'
      }
    },
    // Buttons
    '.jodit-ui-button': {
      '&&&': {
        marginTop: '5px',
        fontSize: '14px',
        backgroundColor: "".concat(BUTTON_COLOR),
        borderColor: "".concat(BUTTON_COLOR),
        height: '32px',
        padding: '4px 16px',
        borderRadius: '4px',
        color: "".concat(BACKGROUND_COLOR),
        textShadow: '0 -1px 0 rgba(0, 0, 0, 0.12)',
        boxShadow: '0 2px 0 rgba(0, 0, 0, 0.045)',
        lineHeight: '1.5715',
        position: 'relative',
        display: 'inline-block',
        fontWeight: 400,
        whiteSpace: 'nowrap',
        textAlign: 'center',
        backgroundImage: 'none',
        border: '1px solid transparent',
        '&:hover': {
          backgroundColor: "".concat(BUTTON_HOVER_COLOR),
          borderColor: "".concat(BUTTON_HOVER_COLOR),
          color: "".concat(BACKGROUND_COLOR)
        }
      }
    },
    // For the color picker tabs
    '.jodit-ui-button.jodit-tabs__button_columns_2': {
      '&&&': {
        background: 'none',
        borderBottom: "2px solid ".concat(TAB_COLOR),
        marginLeft: 0,
        borderRadius: 0,
        color: "".concat(TAB_COLOR),
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: "".concat(TAB_COLOR),
          borderColor: "".concat(TAB_COLOR),
          color: "".concat(BACKGROUND_COLOR)
        },
        '&[aria-pressed="true"]': {
          backgroundColor: "".concat(TAB_COLOR),
          color: "".concat(BACKGROUND_COLOR)
        }
      }
    },
    '.jodit-ui-button__icon': {
      '& > svg': {
        fill: "".concat(BACKGROUND_COLOR)
      }
    },
    // Specific tab buttons
    '.jodit-tabs__button': {
      '&&&[data-ref="link"]': {
        boxShadow: 'none',
        background: "".concat(BACKGROUND_COLOR),
        color: "".concat(BUTTON_TOOLBAR_HOVER_COLOR),
        '& > span > svg': {
          fill: "".concat(BUTTON_TOOLBAR_HOVER_COLOR)
        },
        border: 'none',
        '&:hover': {
          boxShadow: 'none',
          background: "".concat(BACKGROUND_COLOR),
          color: "".concat(BUTTON_TOOLBAR_HOVER_COLOR),
          '& > span > svg': {
            fill: "".concat(BUTTON_TOOLBAR_HOVER_COLOR)
          }
        }
      }
    },
    // Input styling
    '.jodit-ui-input__input': {
      '&&': {
        padding: '4px 11px',
        border: '1px solid #d9d9d9',
        borderRadius: '2px',
        '&:focus': {
          borderColor: "".concat(BUTTON_TOOLBAR_HOVER_COLOR),
          borderRightWidth: '1px',
          outline: '0',
          boxShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)'
        }
      }
    },
    '.jodit-wysiwyg': {
      '& p:first-child': {
        marginTop: 0
      }
    },
    '.jodit-react-container': {
      width: 'inherit',
      height: 'inherit'
    },
    // Color pickup popup overflow
    '.jodit-popup__content': {
      maxHeight: 'none'
    }
  }, _useDynamicFields.styles)
}, {
  name: 'rich-text'
})(() => null);
var _default = OverrideStyles;
exports.default = _default;